import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";

// Función para generar la imagen recortada
const createCroppedImage = async (imageSrc, pixelCrop) => {
  const image = await new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.addEventListener("error", reject);
    img.src = imageSrc;
  });

  const canvas = document.createElement("canvas");
  const size = Math.min(pixelCrop.width, pixelCrop.height);
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    size,
    size
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.92);
  });
};

const ImageCropper = ({ imageSrc, aspect = 1, onCrop, onCancel, titulo = "Ajustá tu foto" }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [procesando, setProcesando] = useState(false);

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleConfirmar = async () => {
    setProcesando(true);
    try {
      const blob = await createCroppedImage(imageSrc, croppedAreaPixels);
      onCrop(blob);
    } catch (err) {
      console.error("Error al recortar:", err);
    }
    setProcesando(false);
  };

  return (
    <div style={{
      position: "fixed", inset: 0, background: "#000", zIndex: 500,
      display: "flex", flexDirection: "column"
    }}>
      {/* header */}
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "16px 20px", paddingTop: 52
      }}>
        <button onClick={onCancel} style={{
          background: "none", border: "none", color: "#fff",
          fontSize: 15, fontWeight: 600, cursor: "pointer"
        }}>
          Cancelar
        </button>
        <span style={{ color: "#fff", fontSize: 16, fontWeight: 700 }}>{titulo}</span>
        <button onClick={handleConfirmar} disabled={procesando} style={{
          background: "#FF4500", border: "none", color: "#fff",
          fontSize: 15, fontWeight: 700, cursor: "pointer",
          padding: "6px 16px", borderRadius: 20, opacity: procesando ? 0.7 : 1
        }}>
          {procesando ? "..." : "Usar"}
        </button>
      </div>

      {/* cropper */}
      <div style={{ position: "relative", flex: 1 }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
          cropShape={aspect === 1 ? "round" : "rect"}
          showGrid={false}
          style={{
            containerStyle: { background: "#000" },
            cropAreaStyle: { border: "2px solid #FF4500" }
          }}
        />
      </div>

      {/* zoom slider */}
      <div style={{ padding: "16px 32px 40px", display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ fontSize: 12, color: "rgba(255,255,255,.5)" }}>−</span>
        <input
          type="range" min={1} max={3} step={0.01}
          value={zoom} onChange={e => setZoom(Number(e.target.value))}
          style={{ flex: 1, accentColor: "#FF4500" }}
        />
        <span style={{ fontSize: 12, color: "rgba(255,255,255,.5)" }}>+</span>
      </div>
    </div>
  );
};

export default ImageCropper;